// Realistic sample template variables for each email type.
// Used by the Admin EmailTester (single + send-all) and template documentation.

export const EMAIL_SAMPLE_VARS: Record<string, Record<string, any>> = {
  welcome: {},
  password_reset: { resetLink: 'https://email2contact.com/auth?reset=sample-token' },
  password_changed: { date: 'April 22, 2026' },
  billing_receipt: { plan: 'Pro', amount: '19.00', date: 'April 22, 2026', receiptUrl: 'https://email2contact.com/settings' },
  payment_failed: { amount: '19.00', dueDate: 'April 25, 2026', invoiceUrl: 'https://email2contact.com/settings' },
  payment_failed_grace_period: {
    amount: 19,
    reason: 'card declined',
    invoice_url: 'https://email2contact.com/settings',
    grace_period_end: 'April 25, 2026',
    days_remaining: 3,
  },
  payment_failed_reminder: {
    days_remaining: 1,
    grace_period_end: 'April 23, 2026',
    credits_remaining: 47,
  },
  credits_expired_payment_failed: { expired_credits: 47 },
  credit_reminder: {
    threshold: '10%',
    percentage: 9,
    credits_remaining: 18,
    credits_monthly: 200,
    tier: 'Pro',
  },
  subscription_active: {
    tier: 'pro',
    billingCycle: 'monthly',
    creditsIncluded: 200,
    nextBillingDate: 'May 22, 2026',
  },
  subscription_renewal: {
    subscriptionTier: 'Pro',
    creditsRefilled: 200,
    billingCycle: 'monthly',
    nextBillingDate: 'May 22, 2026',
  },
  subscription_cancelled: {
    cancellation_date: 'April 22, 2026',
    end_date: 'May 22, 2026',
    credits_remaining: '47',
  },
  subscription_reactivated: {
    tier: 'Pro',
    reactivation_date: 'April 22, 2026',
    next_billing_date: 'May 22, 2026',
  },
  subscription_updated: {
    old_plan: 'Starter',
    new_plan: 'Pro',
    effective_date: 'April 22, 2026',
    is_scheduled: false,
  },
  subscription_scheduled: {
    current_tier: 'Starter',
    current_cycle: 'monthly',
    scheduled_tier: 'Pro',
    scheduled_cycle: 'monthly',
    effective_date: 'May 22, 2026',
  },
  subscription_schedule_cancelled: {
    current_tier: 'Pro',
    current_cycle: 'monthly',
    cancelled_tier: 'Enterprise',
    cancelled_cycle: 'monthly',
  },
  credits_purchased: { package: 'Medium', credits: '50', amount: '18.00' },
  plan_upgrade: {
    current_tier: 'starter',
    suggested_tier: 'pro',
    percentage_used: 92,
    usage_last_7_days: 46,
    current_credits: 50,
    suggested_credits: 200,
  },
  invoice: {
    invoice_number: 'INV-2026-04-0042',
    amount: '19.00',
    currency: 'EUR',
    company_name: 'Acme GmbH',
    invoice_url: 'https://email2contact.com/settings',
    invoice_pdf: 'https://email2contact.com/settings',
  },
  team_invite: { inviter: 'Justus Wiedemann', inviteUrl: 'https://email2contact.com/auth?invite=sample-token' },
  security_notification: { deviceInfo: 'Chrome on macOS', date: 'April 22, 2026 11:42' },
  reactivation: {},
  feedback_request: {},
  gdpr_deletion: {},
  error_credit_refund: { credits: 6, original_cost: 1, bonus: 5 },
};

export const EMAIL_TYPE_LABELS: Record<string, string> = {
  welcome: 'Welcome',
  password_reset: 'Password reset',
  password_changed: 'Password changed',
  billing_receipt: 'Billing receipt',
  payment_failed: 'Payment failed',
  payment_failed_grace_period: 'Payment failed — grace period',
  payment_failed_reminder: 'Payment failed — reminder',
  credits_expired_payment_failed: 'Credits expired (payment failed)',
  credit_reminder: 'Credit reminder',
  subscription_active: 'Subscription active',
  subscription_renewal: 'Subscription renewed',
  subscription_cancelled: 'Subscription cancelled',
  subscription_reactivated: 'Subscription reactivated',
  subscription_updated: 'Subscription plan updated',
  subscription_scheduled: 'Subscription change scheduled',
  subscription_schedule_cancelled: 'Subscription scheduled change cancelled',
  credits_purchased: 'Credits purchased (top-up)',
  plan_upgrade: 'Plan upgrade suggestion',
  invoice: 'Invoice ready',
  team_invite: 'Team invite',
  security_notification: 'Security: new sign-in',
  reactivation: 'Reactivation nudge',
  feedback_request: 'Feedback request',
  gdpr_deletion: 'GDPR deletion confirmation',
  error_credit_refund: 'Error refund + bonus credits',
};

export const ALL_EMAIL_TYPES: string[] = Object.keys(EMAIL_SAMPLE_VARS);
